module.exports = __webpack_public_path__ + "img/teacherIcon3.ca4d03a6.jpg";